import React from 'react'

import { useHistory } from 'react-router-dom'

import { Typography, Button, makeStyles } from '@material-ui/core'

import { InputDebounce } from 'components/Form'
import { routes } from 'routes'
import styles from './styles'

const useStyles = makeStyles(styles)

const SearchBox = ({ onSearch, data }) => {
  const classes = useStyles()
  const history = useHistory()

  const [name, setName] = React.useState('')

  const handleChangeSearch = event => {
    const value = event.target.value

    setName(value)
    onSearch(value)
  }

  const handleClickCreateCustomer = () => {
    history.push(routes.clients.new, {
      from: data.path,
      destination: data.destination,
    })
  }

  return (
    <div className={classes.root}>
      <InputDebounce
        label="Pesquisar"
        margin="dense"
        className={classes.inputSeach}
        name="search"
        value={name}
        onChange={handleChangeSearch}
      />
      <Typography className={classes.orText}>ou</Typography>
      <Button
        variant="outlined"
        color="primary"
        margin="dense"
        onClick={handleClickCreateCustomer}
        className={classes.buttonCreateCustomer}
      >
        Incluir novo cliente
      </Button>
    </div>
  )
}

export default SearchBox
